import { render, staticRenderFns } from "./MaydayNodeMain.vue?vue&type=template&id=464bbf78&scoped=true&"
import script from "./MaydayNodeMain.vue?vue&type=script&lang=js&"
export * from "./MaydayNodeMain.vue?vue&type=script&lang=js&"
import style0 from "./MaydayNodeMain.vue?vue&type=style&index=0&id=464bbf78&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464bbf78",
  null
  
)

export default component.exports